module.exports = __webpack_public_path__ + "static/media/wedding2.51b06c41.jpeg";